import React from 'react';
import { ReactComponent as StripeLogo } from '../../svg/filled/stripe.svg'

export const StripeInfoCard = ({ checkoutTitleStripe,descStripe = null, activeBox=true, onClick, loading }) => (
    <div
        className="card__container"
        style={!activeBox ? { opacity: 0.4, pointerEvents: 'none' } : {}}
    >
        <div>
            <h3 className="card__title">{checkoutTitleStripe}</h3>
            <span className="card__description">
         {descStripe ?? "It may take up to 5 minutes for the payment process"}
      </span>
        </div>
        <div className="card__item">
            <StripeLogo className="card__logo" />
        </div>

            <div className="card__item">
                <button
                    disabled={loading}
                    onClick={onClick}
                    type="button"
                    className="button card__button button--proceed"
                >
                    <span className="text-2 bold">Pay Now</span>
                </button>
            </div>

    </div>
);
